import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Card } from "../components/ui/uiImport";
import { SyncIcon } from "../common/iconsData";
import { DataTableForMobile } from "../components/features/returns/ReturnTableMobile";

import {
  Tab,
  Box,
  Button,
  Checkbox,
  Autocomplete,
  TextField,
  Drawer,
  Tabs,
  Stack,
  useMediaQuery,
} from "@mui/material";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Title from "../components/ui/Title";
import AddIcon from "@mui/icons-material/Add";
import { CustomTabPanel } from "../components/ui/CustomTabPanel";
import DatePickerEl from "../components/ui/DatePickerEl";
import dayjs, { Dayjs } from "dayjs";
import { returnsTab } from "../common/data";
import { Link, useSearchParams } from "react-router-dom";
import { useServiceDrawer } from "../components/features/returns/useServiceDrawer";
import {
  returnRowType,
  TabCol,
} from "../components/features/returns/RetrunData";
import CustomDataTable from "../components/ui/CustomDataTable";
import { GetAllReturns } from "../components/features/returns/returnApi";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import MultipleReturnsAssignDrawer from "../components/features/returns/MultipleReturnsAssignDrawer";
import { FilterAlt } from "@mui/icons-material";
import useReturnFilter from "../components/features/returns/ReturnFilterDrawer";
import { ReturnFilter } from "../components/features/returns/filter";
import { StyledButton } from "../components/ui/StyledButton";

const InsideButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 12px;
`;

const reasonFilter = [
  {
    label: "Arried too late",
  },
  {
    label: "Changed my mind",
  },
  {
    label: "Does not fit",
  },
  {
    label: "item is damaged",
  },
];

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};
const Returns = () => {
  const matches = useMediaQuery("(min-width:600px)");

  const {
    startDate,
    endDate,
    page,
    activeTab,
    setTotalRow,
    handleDateChange,
    handleTabChange,
    totalRow,
    updatePage,
    shipmentParams,
  } = useReturnFilter();

  const { syncReturns, setSyncReturns } = useServiceDrawer();

  const [drawer, setDrawer] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const transportParams = searchParams.get("reason") || "Arried too late";

  const toggleDrawer = () => {
    setDrawer(!drawer);
  };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  useEffect(() => {
    setTotalRow(1);
    fetchAllReturnsMethod();
  }, [startDate, endDate, page, activeTab, syncReturns]);

  const [allReturns, setAllReturns] = useState<returnRowType[]>([]);

  const fetchAllReturnsMethod = () => {
    GetAllReturns(
      startDate as Dayjs,
      endDate as Dayjs,
      page,
      returnsTab[activeTab].filter
    )
      .then((data) => {
        let allData: any[] = [];

        if (data.data.data.data) {
          allData = [...data.data?.data?.data];
          setTotalRow(data?.data?.data?.pages_count);
          setAllReturns(allData);
        } else {
          setAllReturns([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setAllReturns([]);
      });
  };

  const [selectedId, setSelectedId] = useState<GridRowSelectionModel>([]);

  const selectedData = allReturns?.filter((el) => {
    return selectedId.includes(el.id);
  });

  const bulkActionHandler = (e: GridRowSelectionModel) => {
    setSelectedId(e);
  };

  const [openMultiple, setOpenMultiple] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  return (
    <>
      <Title title="Returns" />
      <Card>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          flexWrap={"wrap"}
          rowGap={"20px"}
          columnGap={"20px"}
          marginBottom={"40px"}
        >
          <div className="common-filters">
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              flexWrap={"wrap"}
              columnGap={"20px"}
              rowGap={"20px"}
            >
              <DatePickerEl
                defaultDate={startDate}
                handleChange={(time) => handleDateChange(time, "start")}
                label="From"
              />
              <DatePickerEl
                defaultDate={endDate}
                handleChange={(time) => handleDateChange(time, "end")}
                label="To"
              />
            </Stack>
          </div>
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            flexWrap={"wrap"}
            columnGap={"20px"}
            rowGap={"20px"}
          >
            <div className="order-filter-button">
              <Button
                onClick={() => setOpenFilter(true)}
                sx={{
                  padding: "6px 20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "4px",
                  fontSize: "12px",
                }}
                variant="contained"
              >
                <FilterAlt
                  sx={{
                    fontSize: "16px",
                  }}
                />
                <p>Filters</p>
              </Button>
            </div>

            <StyledButton
              sx={{
                padding: "6px 20px",
              }}
              variant="contained"
              disabled={!(selectedId.length > 0)}
              onClick={() => setOpenMultiple(true)}
            >
              <InsideButton>
                <p>Bulk&nbsp;Action</p>
              </InsideButton>
            </StyledButton>

            <Link to="add-returns">
              <StyledButton variant="contained">
                <InsideButton>
                  <AddIcon
                    sx={{
                      fontSize: "16px",
                    }}
                  />
                  <p> Add Returns</p>
                </InsideButton>
              </StyledButton>
            </Link>
            <StyledButton
              sx={{
                paddingLeft: "8px",
              }}
              variant="outlined"
              onClick={() => setSyncReturns()}
            >
              <InsideButton>
                <SyncIcon
                  sx={{
                    fontSize: "16px",
                  }}
                />
                <p>Sync&nbsp;Returns</p>
              </InsideButton>
            </StyledButton>
          </Stack>
        </Stack>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={activeTab}
            onChange={(e: React.SyntheticEvent<Element, Event>, number: any) =>
              handleTabChange(e, number, shipmentParams)
            }
            variant="scrollable"
          >
            {returnsTab.map((returnsTab, index) => {
              return (
                <Tab
                  key={index}
                  label={returnsTab.label}
                  {...a11yProps(index)}
                />
              );
            })}
          </Tabs>
        </Box>

        <CustomTabPanel value={activeTab} index={activeTab}>
          {matches ? (
            <CustomDataTable
              page={page}
              totalRow={totalRow}
              updatePage={updatePage}
              rows={allReturns}
              columns={TabCol[activeTab].column}
              checkBox={activeTab === 0}
              onRowSelectionModelChange={bulkActionHandler}
              total={allReturns.length}
              wantExcel={false}
            />
          ) : (
            <DataTableForMobile
              rows={allReturns}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
              checkBox={activeTab === 0}
              page={page}
              totalRow={totalRow}
              updatePage={updatePage}
            />
          )}
        </CustomTabPanel>
      </Card>

      <MultipleReturnsAssignDrawer
        ids={selectedId}
        handleClose={() => {
          setOpenMultiple(false);
          setSyncReturns();
        }}
        open={openMultiple}
        data={selectedData}
      />

      <ReturnFilter
        open={openFilter}
        onClose={() => setOpenFilter(false)}
        startDate={startDate}
        endDate={endDate}
        handleDateChange={handleDateChange}
      />
    </>
  );
};

export default Returns;
